import { ActionsUnion, createAction } from '../../../redux/customActions';

export const Actions = {
    userInfoUpdateRequested: () => createAction('userInfo/userInfoUpdateRequested'),
    userInfoUpdateFailed: () => createAction('userInfo/userInfoUpdateRequestFailed'),
    userInfoUpdateSucceed: () => createAction('userInfo/userInfoUpdateRequestSucceed'),
};

export type ActionsType = ActionsUnion<typeof Actions>;
